module.exports = __webpack_public_path__ + "img/icon-automation.ff52387b.png";